import { Avatar, Card, Group, Text } from '@mantine/core';
import { IModel } from '../ModelCard/ModelCard';
import classes from './CreatorCard.module.css';
import { Wrapper } from './CreatorCard.style';

const stats = [
  { value: '34K', label: 'Likes' },
  { value: '187', label: 'Views' },
  { value: '1.6K', label: 'Followers' },
];

export type CreatorCardProps = {
  model: IModel;
};

export function CreatorCard(props: CreatorCardProps) {
  const { model } = props;
  const { uploaderName, uploaderAvatar } = model ?? {};

  const items = stats.map((stat) => (
    <div key={stat.label}>
      <Text ta='center' fz='sm' fw={500}>
        {stat.value}
      </Text>
      <Text ta='center' fz='xs' c='dimmed' lh={1}>
        {stat.label}
      </Text>
    </div>
  ));

  return (
    <Wrapper className='CreatorCard-wrapper' data-testid='CreatorCard-wrapper'>
      <Card withBorder padding='xl' radius='md' className={classes.card}>
        <Card.Section
          h={60}
          style={{
            backgroundImage: 'linear-gradient(135deg, #252c39 0%, #3c4257 100%)',
          }}
        />
        <Avatar
          src={uploaderAvatar}
          size={80}
          radius={80}
          mx='auto'
          mt={-30}
          className={classes.avatar}
        />
        <Text ta='center' fz='lg' fw={500} mt='sm'>
          {uploaderName}
        </Text>
        <Text ta='center' fz='sm' c='dimmed'>
          Fullstack engineer
        </Text>
        <Group mt='md' justify='center' gap={10}>
          {items}
        </Group>
      </Card>
    </Wrapper>
  );
}

export default CreatorCard;
